export const Language = {
  NONE: "-1",
  ENGLISH: "1",
  SPANISH: "2",
  RUSSIAN: "3",
  JAPANESE: "4",
  ITALIAN: "5",
  FRENCH: "6",
  CHINESE: "7",
  AMERICAN_SIGN: "8",
  LATIN: "9",
  GERMAN: "10",
  KOREAN: "11",
  MANDARIN: "12",
  PUNJABI: "13",
  VIETNAMESE: "14",
  ARABIC: "15",
  PORTUGUESE: "16",
  HMONG: "18",
  LAO: "19",
  ARMENIAN: "20",
  FARSI: "21",
  OTHER: "999",
} as const;

export type Language = (typeof Language)[keyof typeof Language];

export const LANGUAGE_LABELS: Record<Language, string> = {
  [Language.NONE]: "",
  [Language.ENGLISH]: "English",
  [Language.SPANISH]: "Spanish",
  [Language.RUSSIAN]: "Russian",
  [Language.JAPANESE]: "Japanese",
  [Language.ITALIAN]: "Italian",
  [Language.FRENCH]: "French",
  [Language.CHINESE]: "Chinese",
  [Language.AMERICAN_SIGN]: "American Sign Language",
  [Language.LATIN]: "Latin",
  [Language.GERMAN]: "German",
  [Language.KOREAN]: "Korean",
  [Language.MANDARIN]: "Mandarin",
  [Language.PUNJABI]: "Punjabi",
  [Language.VIETNAMESE]: "Vietnamese",
  [Language.ARABIC]: "Arabic",
  [Language.PORTUGUESE]: "Portuguese",
  [Language.HMONG]: "Hmong",
  [Language.LAO]: "Lao",
  [Language.ARMENIAN]: "Armenian",
  [Language.FARSI]: "Farsi",
  [Language.OTHER]: "Other",
};

export const LanguageProficiency = {
  NONE: "-1",
  ELEMENTARY: "0",
  LIMITED_WORKING: "1",
  PROFESSIONAL_WORKING: "2",
  FULL_PROFESSIONAL: "3",
  NATIVE_BILINGUAL: "4",
} as const;

export type LanguageProficiency =
  (typeof LanguageProficiency)[keyof typeof LanguageProficiency];

export const LANGUAGE_PROFICIENCY_LABELS: Record<LanguageProficiency, string> =
  {
    [LanguageProficiency.NONE]: "",
    [LanguageProficiency.ELEMENTARY]: "Elementary",
    [LanguageProficiency.LIMITED_WORKING]: "Limited working",
    [LanguageProficiency.PROFESSIONAL_WORKING]: "Professional working",
    [LanguageProficiency.FULL_PROFESSIONAL]: "Full professional",
    [LanguageProficiency.NATIVE_BILINGUAL]: "Native / bilingual",
  };
